import employeeAxios from '../../../axios/employee'
import { enqueueSnackbar } from '../../actions'
import {
  IMPORT_SALARY_SUCCESS,
  IMPORT_SALARY_START,
  IMPORT_SALARY_FAILED,
  IMPORT_SALARY_PROGRESS
} from '../actionTypes/actionTypes'

export const importSalary = importFile => {
  return dispatch => {
    dispatch(importSalaryStart())
    const formData = new FormData()
    formData.append('file', importFile)

    const config = {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        dispatch(importSalaryProgress(percentCompleted))
      }
    }

    employeeAxios
      .post('salary/import', formData, config)
      .then(response => {
        if (response.status === 200) {
          dispatch(importSalarySuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Import Salary Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(err => {
        console.log(err, { ...err })
        const statusCode = err?.response?.status ?? null
        switch (statusCode) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Import Salary Failed',
                options: { variant: 'error', data: err.response?.data?.data ?? [] }
              })
            )
            break
          case 500:
            dispatch(
              enqueueSnackbar({
                message: 'Server Error, Please try again later.',
                options: { variant: 'error' }
              })
            )
            break
          default:
            break
        }
        dispatch(importSalaryFailed())
      })
  }
}

const importSalaryStart = () => {
  return {
    type: IMPORT_SALARY_START
  }
}

const importSalaryProgress = progress => {
  return {
    type: IMPORT_SALARY_PROGRESS,
    progress
  }
}

const importSalarySuccess = () => {
  return {
    type: IMPORT_SALARY_SUCCESS
  }
}

const importSalaryFailed = () => {
  return {
    type: IMPORT_SALARY_FAILED
  }
}
